<template>
  <div class="phone-tab phone" v-if="tabShow">
    <div class="each-phone-tab flex" @click="productFontClick(0)">
      <router-link class="black-6 " to="/home">{{
        $t("localization.homeFont")
      }}</router-link>
    </div>
    <div class="each-phone-tab flex">
      <div
        class="each-phone-tab flex flex1"
        :class="{ 'a-bg': TabIndex == 2 }"
        style="padding:0"
        @click="productFontClick(2)"
      >
        <router-link class="black-6 " to="">{{
          $t("localization.schemeFont")
        }}</router-link>
        <img
          v-if="schemeFont"
          src="../../../assets/images/index/bot.png"
          alt=""
        />
        <img v-else src="../../../assets/images/index/right.png" alt="" />
      </div>
      <div class="each-tab-pop" v-show="schemeFont">
        <div class="tab-pop black-6" @click="goEachPhoneSolution(3)">
          {{ $t("localization.logisticsSolveFont") }}
        </div>
        <div class="tab-pop black-6" @click="goEachPhoneSolution(2)">
          {{ $t("localization.factorySolveFont") }}
        </div>
        <div class="tab-pop black-6" @click="goEachPhoneSolution(1)">
          {{ $t("localization.gardenSolveFont") }}
        </div>
      </div>
    </div>
    <div class="each-phone-tab flex">
      <div
        class="each-phone-tab flex flex1"
        :class="{ 'a-bg': TabIndex == 1 }"
        style="padding:0"
        @click="productFontClick(1)"
      >
        <router-link class="black-6 " to="/productCenter">{{
          $t("localization.productFont")
        }}</router-link>

        <img
          v-if="productFont"
          src="../../../assets/images/index/bot.png"
          alt=""
        />
        <img v-else src="../../../assets/images/index/right.png" alt="" />
      </div>
      <div class="each-tab-pop" v-show="productFont">
        <div class="tab-pop2 text-color">
          {{ $t("localization.newProduct") }}
        </div>
        
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplication"
            target="_blank"
            >{{ $t("localization.newProductData31") }}</a
          >
        </div>
        
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/it/"
            target="_blank"
            >{{ $t("localization.newProductData33") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="https://cloud.nti56.com/iiot/login"
            target="_blank"
            >{{ $t("localization.newProductData35") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/ntibigdata/#/login"
            target="_blank"
            >{{ $t("localization.newProductData37") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="https://cloud.nti56.com/dtts/auth/home"
            target="_blank"
            >{{ $t("localization.newProductData39") }}</a
          >
        </div>
        <div class="tab-pop2 text-color">
          {{ $t("localization.newProductData29") }}
        </div>
        
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplication"
            target="_blank"
            >{{ $t("localization.newProductData4") }}</a
          >
        </div>
        
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplication"
            target="_blank"
            >{{ $t("localization.newProductData7") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplication"
            target="_blank"
            >{{ $t("localization.newProductData26") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplication"
            target="_blank"
            >{{ $t("localization.newProductData27") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplicationDetail"
            target="_blank"
            >{{ $t("localization.newProductData16") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplicationDetail"
            target="_blank"
            >{{ $t("localization.newProductData17") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplicationDetail"
            target="_blank"
            >{{ $t("localization.newProductData18") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplication"
            target="_blank"
            >{{ $t("localization.newProductData19") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplication"
            target="_blank"
            >{{ $t("localization.newProductData21") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplication"
            target="_blank"
            >{{ $t("localization.newProductData22") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplication"
            target="_blank"
            >{{ $t("localization.newProductData23") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplication"
            target="_blank"
            >{{ $t("localization.newProductData24") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplication"
            target="_blank"
            >{{ $t("localization.newProductData1") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplication"
            target="_blank"
            >{{ $t("localization.newProductData3") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplication"
            target="_blank"
            >{{ $t("localization.newProductData6") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplication"
            target="_blank"
            >{{ $t("localization.newProductData9") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplication"
            target="_blank"
            >{{ $t("localization.newProductData10") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplication"
            target="_blank"
            >{{ $t("localization.newProductData11") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplication"
            target="_blank"
            >{{ $t("localization.newProductData12") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplication"
            target="_blank"
            >{{ $t("localization.newProductData13") }}</a
          >
        </div>
        <div class="tab-pop " @click="hidePhonePop">
          <a
            class="black-6"
            href="http://cloud.nti56.com/webApplication"
            target="_blank"
            >{{ $t("localization.newProductData14") }}</a
          >
        </div>
        <div class="tab-pop2 text-color">
          {{ $t("localization.productFont3") }}
        </div>
        <div class="tab-pop black-6" @click="goAgv">
          {{ $t("localization.AGVFont") }}
        </div>
        <div class="tab-pop black-6" @click="goPiler">
          {{ $t("localization.stackerFont") }}
        </div>
       
        
      </div>
    </div>

    <div class="each-phone-tab flex" @click="productFontClick(3)">
      <router-link class="black-6 " to="/succeedCase">{{
        $t("localization.caseFont")
      }}</router-link>
    </div>
    <div class="each-phone-tab flex">
      <div
        class="each-phone-tab flex flex1"
        :class="{ 'a-bg': TabIndex == 4 }"
        style="padding:0"
        @click="productFontClick(4)"
      >
        <router-link class="black-6 " to="/serviceSupport">{{
          $t("localization.serveFont")
        }}</router-link>
        <img
          v-if="serveFont"
          src="../../../assets/images/index/bot.png"
          alt=""
        />
        <img v-else src="../../../assets/images/index/right.png" alt="" />
      </div>
      <div class="each-tab-pop" v-show="serveFont">
        <div class="tab-pop black-6" @click="goServe(1)">
          {{ $t("localization.serviceSupportFont51") }}
        </div>
        <div class="tab-pop black-6" @click="goServe(2)">
          {{ $t("localization.serviceSupportFont2") }}
        </div>
        <div class="tab-pop black-6" @click="goServe(3)">
          {{ $t("localization.serviceSupportFont10") }}
        </div>
        <div class="tab-pop black-6" @click="goServe(4)">
          {{ $t("localization.serviceSupportFont23") }}
        </div>
      </div>
    </div>

    <div class="each-phone-tab flex" v-if="voiceData == 'zh-CN'">
      <div
        class="each-phone-tab flex flex1"
        :class="{ 'a-bg': TabIndex == 5 }"
        style="padding:0"
        v-if="voiceData == 'zh-CN'"
        @click="productFontClick(5)"
      >
        <router-link class="black-6 " to="#">{{
          $t("localization.investorFont")
        }}</router-link>
        <img
          v-if="investorFont"
          src="../../../assets/images/index/bot.png"
          alt=""
        />
        <img v-else src="../../../assets/images/index/right.png" alt="" />
      </div>
      <div class="each-tab-pop" v-show="investorFont">
        <!-- <div class="tab-pop black-6" @click="goInvest(1)">
          {{ $t("localization.stockmarket") }}
        </div> -->
        <div class="tab-pop black-6" @click="goInvest(2)">
          {{ $t("localization.secretaries") }}
        </div>
        <!-- <div class="tab-pop black-6" @click="goInvest(3)">
          {{ $t("localization.investorNews") }}
        </div> -->

        <div class="tab-pop" @click="hidePhonePop">
          <a
            class="black-6"
            rel="noopener noreferrer"
            href="http://www.cninfo.com.cn/new/fulltextSearch?notautosubmit=&keyWord=%E4%BB%8A%E5%A4%A9%E5%9B%BD%E9%99%85"
            target="_blank"
            >{{ $t("localization.notice") }}</a
          >
        </div>
        <div class="tab-pop" @click="hidePhonePop">
          <a
            class="black-6"
            rel="noopener noreferrer"
            href="http://irm.cninfo.com.cn/ircs/company/companyDetail?stockcode=300532&orgId=9900021797"
            target="_blank"
            >{{ $t("localization.interact") }}</a
          >
        </div>
      </div>
    </div>
    <div class="each-phone-tab flex">
      <div
        class="each-phone-tab flex flex1"
        :class="{ 'a-bg': TabIndex == 6 }"
        style="padding:0"
        @click="productFontClick(6)"
      >
        <router-link class="black-6 " to="/aboutUs">{{
          $t("localization.aboutFont")
        }}</router-link>
        <img
          v-if="aboutFont"
          src="../../../assets/images/index/bot.png"
          alt=""
        />
        <img v-else src="../../../assets/images/index/right.png" alt="" />
      </div>
      <div class="each-tab-pop" v-show="aboutFont">
        <div class="tab-pop black-6" @click="goAboutUs(1)">
          {{ $t("localization.aboutFont14") }}
        </div>
        
        <div class="tab-pop black-6" @click="goAboutUs(2)">
          {{ $t("localization.aboutFont9") }}
        </div>
        <div class="tab-pop black-6" @click="goAboutUs(3)">
          {{ $t("localization.aboutFont10") }}
        </div>
        <div class="tab-pop black-6" @click="goAboutUs(4)" v-if="voiceData=='zh-CN'">
          {{ $t("localization.aboutFont37") }}
        </div>
        <div class="tab-pop black-6" @click="goAboutUs(5)">
          {{ $t("localization.aboutFont13") }}
        </div>
        <div class="tab-pop black-6" @click="goAboutUs(6)">
          {{ $t("localization.aboutFont12") }}
        </div>
        <div class="tab-pop black-6" @click="goAboutUs(7)">
          {{ $t("localization.aboutFont11") }}
        </div>
        <div class="tab-pop black-6" @click="goAboutUs(8)">
          {{ $t("localization.aboutFont15") }}
        </div>
        <div class="tab-pop black-6" @click="goAboutUs(9)">
          {{ $t("localization.video") }}
        </div>
        <div class="tab-pop black-6" @click="goAboutUs(10)">
          {{ $t("localization.aboutFont42") }}
        </div>
      </div>
    </div>
    <div
      class="each-phone-tab flex"
      v-if="voiceData == 'zh-CN'"
      @click="productFontClick(7)"
    >
      <router-link class="black-6 " to="/joinUs">{{
        $t("localization.joinUsFont")
      }}</router-link>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tabShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      TabIndex: null,
      productFont: false,
      schemeFont: false,
      voiceData: "zh-CN",
      aboutFont: false,
      investorFont: false,
      serveFont: false
    };
  },
  mounted() {
    this.voiceData =
      localStorage.getItem("DefaultLanguage") == null
        ? "zh-CN"
        : localStorage.getItem("DefaultLanguage");
    window.addEventListener("setItem", e => {
      if (e.key == "DefaultLanguage") {
        if (e.newValue == "en-US") {
          this.voiceData = "en-US";
        } else {
          this.voiceData = "zh-CN";
        }
      }
    });
  },
  methods: {
    goAgv() {
      this.$emit("hidePop");
      this.$router.push("/AGVDetails");
    },
    goPiler() {
      this.$emit("hidePop");
      this.$router.push("/pilerDetails");
    },
    goEachPhoneSolution(index) {
      if (index == 1) {
        this.$router.push("/gardenSolution");
      } else if (index == 2) {
        this.$router.push("/plantSolution");
      } else if (index == 3) {
        this.$router.push("/logisticsSolution");
      }
      this.$emit("hidePop");
    },
    goAboutUs(data) {
      this.$addStorageEvent("aboutChildren", data);
      if (data == 1) {
        this.$router.push("/aboutUs/chairman");
        
      } else if (data == 2) {
        this.$router.push("/aboutUs/electricity");
       
      } else if (data == 3) {
        this.$router.push("/aboutUs/development");
     
      } else if (data == 4) {
        this.$router.push("/aboutUs/contactUs");
       
      } else if (data == 5) {
        this.$router.push("/aboutUs/culture");
      
      } else if (data == 6) {
        this.$router.push("/aboutUs/responsibility");
      } else if (data == 7) {
        this.$router.push("/aboutUs/certification");
      } else if (data == 8) {
        this.$router.push("/aboutUs/journalism");
      } else if (data == 9) {
        this.$router.push("/aboutUs/videoDetails");
      } else if (data == 10) {
        this.$router.push("/aboutUs/downloadCenter");
      }

      this.$emit("hidePop");
    },
    goServe(index) {
      this.$emit("hidePop");
      this.$router.push({
        path: "/serviceSupport",
        query: {
          anchor: index
        }
      });
    },

    productFontClick(item) {
      if (item == 1 || item == 2 || item == 6 || item == 5 || item == 4) {
        if (item == 1) {
          this.productFont = !this.productFont;
          this.schemeFont = false;
          this.aboutFont = false;
          this.investorFont = false;
        } else {
          this.productFont = false;
        }
        if (item == 2) {
          this.schemeFont = !this.schemeFont;
          this.productFont = false;
          this.aboutFont = false;
          this.investorFont = false;
        } else {
          this.schemeFont = false;
        }
        if (item == 6) {
          this.aboutFont = !this.aboutFont;
          this.productFont = false;
          this.schemeFont = false;
          this.investorFont = false;
        } else {
          this.aboutFont = false;
        }
        if (item == 5) {
          this.investorFont = !this.investorFont;
          this.aboutFont = false;
          this.productFont = false;
          this.schemeFont = false;
        } else {
          this.investorFont = false;
        }
        if (item == 4) {
          this.serveFont = !this.serveFont;
          this.aboutFont = false;
          this.productFont = false;
          this.schemeFont = false;
          this.investorFont = false;
        } else {
          this.serveFont = false;
        }
      } else {
        this.$emit("hidePop");
      }
      if (item == 6) {
        sessionStorage.setItem("aboutIndex", 0);
      }
      this.TabIndex = item;
    },
    hidePhonePop() {
      this.$emit("hidePop");
    },
    goInvest(data) {
      if (data == 1) {
        this.$router.push({
          path: "/stockmarket"
        });
      } else if (data == 2) {
        this.$router.push({
          path: "/secretaries"
        });
      } else if (data == 3) {
        this.$router.push({
          path: "/investorNews"
        });
      }

      this.$emit("hidePop");
    }
  }
};
</script>
<style lang="scss" scoped>
.phone-tab {
  width: 100%;
  position: fixed;
  top: 60px;
  left: 0;
  height: calc(100vh - 60px);
  background-color: #fff;
  z-index: 10;
  overflow-y: scroll;
  .each-phone-tab {
    min-height: 36px;
    padding-left: 10px;
    font-size: 16px;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    cursor: pointer;
    position: relative;
    a {
      width: 100%;
    }
    img {
      width: 24px;
      height: 24px;
      position: absolute;
      right: 30px;
      top: 6px;
    }
    .each-tab-pop {
      padding: 10px 15px;
      width: 100%;
      font-size: 14px;
      .tab-pop {
        width: 100%;
        height: 32px;
        line-height: 32px;
        a {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .tab-pop2 {
        width: 100%;
        height: 38px;
        line-height: 36px;
        font-size: 16px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        cursor: auto;
      }
    }
  }
  .a-bg {
    // background: rgba(199, 0, 10, 0.2);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/header-pop/phone-tab.vue